import React, { useEffect, useState } from "react";

import { Card, Modal } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { editFaq } from "../../services/UserServices/UserService";
import { useLocation, useNavigate } from "react-router-dom";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import { Editor } from "@tinymce/tinymce-react";

export default function EditFaqs() {
  let errorsObj = { question: "", answer: "", question_ch: "", answer_ch: "", question_zh: "", answer_zh: "", question_ms: "", answer_ms: "", question_id: "", answer_id: "", question_vi: "", answer_vi: "", question_ko: "", answer_ko: "", question_ja: "", answer_ja: "", question_hi: "", answer_hi: "" };
  const location = useLocation();
  const categoryId = location.state.category;
  const title = location.state.title;
  const navigate = useNavigate();
  const data = location.state?.data;
  const faqId = location.state?.faqId;
  const [errors, setErrors] = useState(errorsObj);
  const [formData, setFormData] = useState({
    question: "",
    question_ch: "",
    answer: "",
    answer_ch: "",
    question_zh: "",
    answer_zh: "",
    question_ms: "",
    answer_ms: "",
    question_id: "",
    answer_id: "",
    question_vi: "",
    answer_vi: "",
    question_ko: "",
    answer_ko: "",
    question_ja: "",
    answer_ja: "",
    question_hi: "",
    answer_hi: "",
    faqId: "",
    questionId: "",
  });

  const [loader, setLoader] = useState(false);
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const handleChangeText = (content) => {
    setFormData({ ...formData, answer: content });
    setErrors({ ...errors, answer: "" });
  };
  const handleChangeTextCh = (content) => {
    setFormData({ ...formData, answer_ch: content });
    setErrors({ ...errors, answer_ch: "" });
  };
  const handleChangeTextZh = (content) => {
    setFormData({ ...formData, answer_zh: content });
    setErrors({ ...errors, answer_zh: "" });
  };
  const handleChangeTextMs = (content) => {
    setFormData({ ...formData, answer_ms: content });
    setErrors({ ...errors, answer_ms: "" });
  };
  const handleChangeTextId = (content) => {
    setFormData({ ...formData, answer_id: content });
    setErrors({ ...errors, answer_id: "" });
  };
  const handleChangeTextVi = (content) => {
    setFormData({ ...formData, answer_vi: content });
    setErrors({ ...errors, answer_vi: "" });
  };
  const handleChangeTextKo = (content) => {
    setFormData({ ...formData, answer_ko: content });
    setErrors({ ...errors, answer_ko: "" });
  };
  const handleChangeTextJa = (content) => {
    setFormData({ ...formData, answer_ja: content });
    setErrors({ ...errors, answer_ja: "" });
  };
  const handleChangeTextHi = (content) => {
    setFormData({ ...formData, answer_hi: content });
    setErrors({ ...errors, answer_hi: "" });
  };
  //// function to post data ///
  const onSubmit = async (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (formData?.question.trim() === "") {
      errorObj.question = "This fiels is required";
      error = true;
    }
    if (formData?.answer.trim() === "") {
      errorObj.answer = "This fiels is required";
      error = true;
    }
    if (formData?.question_ch.trim() === "") {
      errorObj.question_ch = "This fiels is required";
      error = true;
    }
    if (formData?.answer_ch.trim() === "") {
      errorObj.answer_ch = "This fiels is required";
      error = true;
    }
    if (formData?.question_zh.trim() === "") {
      errorObj.question_zh = "This fiels is required";
      error = true;
    }
    if (formData?.answer_zh.trim() === "") {
      errorObj.answer_zh = "This fiels is required";
      error = true;
    }
    if (formData?.question_ms.trim() === "") {
      errorObj.question_ms = "This fiels is required";
      error = true;
    }
    if (formData?.answer_ms.trim() === "") {
      errorObj.answer_ms = "This fiels is required";
      error = true;
    }
    if (formData?.question_id.trim() === "") {
      errorObj.question_id = "This fiels is required";
      error = true;
    }
    if (formData?.answer_id.trim() === "") {
      errorObj.answer_id = "This fiels is required";
      error = true;
    }
    if (formData?.question_vi.trim() === "") {
      errorObj.question_vi = "This fiels is required";
      error = true;
    }
    if (formData?.answer_vi.trim() === "") {
      errorObj.answer_vi = "This fiels is required";
      error = true;
    }
    if (formData?.question_ko.trim() === "") {
      errorObj.question_ko = "This fiels is required";
      error = true;
    }
    if (formData?.answer_ko.trim() === "") {
      errorObj.answer_ko = "This fiels is required";
      error = true;
    }
    if (formData?.question_ja.trim() === "") {
      errorObj.question_ja = "This fiels is required";
      error = true;
    }
    if (formData?.answer_ja.trim() === "") {
      errorObj.answer_ja = "This fiels is required";
      error = true;
    }
    if (formData?.question_hi.trim() === "") {
      errorObj.question_hi = "This fiels is required";
      error = true;
    }
    if (formData?.answer_hi.trim() === "") {
      errorObj.answer_hi = "This fiels is required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    setLoader(true);
    try {
      const response = await editFaq(formData);
      notifyTopRight(response?.data?.message);
      setFormData({ question: "", answer: "", question_ch: "", answer_ch: "", question_zh: "", answer_zh: "", question_ms: "", answer_ms: "", question_id: "", answer_id: "", question_vi: "", answer_vi: "", question_ko: "", answer_ko: "", question_ja: "", answer_ja: "", question_hi: "", answer_hi: "", categoryId: "" });

      navigate("/faqs-list", {
        state: { id: categoryId, title: title },
      });
      setLoader(false);
    } catch (error) {
      setLoader(false);
      notifyError(error.response?.data?.message);
    }
  };
  useEffect(() => {
    setFormData({
      question: data?.question,
      answer: data?.answer,
      question_ch: data?.question_ch,
      answer_ch: data?.answer_ch,
      question_zh: data?.question_zh,
      answer_zh: data?.answer_zh,
      question_ms: data?.question_ms,
      answer_ms: data?.answer_ms,
      question_id: data?.question_id,
      answer_id: data?.answer_id,
      question_vi: data?.question_vi,
      answer_vi: data?.answer_vi,
      question_ko: data?.question_ko,
      answer_ko: data?.answer_ko,
      question_ja: data?.question_ja,
      answer_ja: data?.answer_ja,
      question_hi: data?.question_hi, 
      answer_hi: data?.answer_hi,
      faqId: faqId,
      questionId: data?._id,
    });
  }, [data]);
  return (
    <Card>
      <form onSubmit={onSubmit}>
        <div className="card-header">
          <h4 className="card-title fs-20">Edit Details</h4>
        </div>
        <div className="card-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (English)</label>
            <input
              className="form-control"
              name="question"
              value={formData.question}
              onChange={handleInput}
            />
            {errors.question && (
              <div className="text-danger fs-12">{errors.question}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Chinese)</label>
            <input
              className="form-control"
              name="question_ch"
              value={formData.question_ch}
              onChange={handleInput}
            />
            {errors.question_ch && (
              <div className="text-danger fs-12">{errors.question_ch}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Chinese traditional)</label>
            <input
              className="form-control"
              name="question_zh"
              value={formData.question_zh}
              onChange={handleInput}
            />
            {errors.question_zh && (
              <div className="text-danger fs-12">{errors.question_zh}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Malay bahasa melayu)</label>
            <input
              className="form-control"
              name="question_ms"
              value={formData.question_ms}
              onChange={handleInput}
            />
            {errors.question_ms && (
              <div className="text-danger fs-12">{errors.question_ms}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Indonesian bahasa indonesia)</label>
            <input
              className="form-control"
              name="question_id"
              value={formData.question_id}
              onChange={handleInput}
            />
            {errors.question_id && (
              <div className="text-danger fs-12">{errors.question_id}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Vietnamese)</label>
            <input
              className="form-control"
              name="question_vi"
              value={formData.question_vi}
              onChange={handleInput}
            />
            {errors.question_vi && (
              <div className="text-danger fs-12">{errors.question_vi}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Korean)</label>
            <input
              className="form-control"
              name="question_ko"
              value={formData.question_ko}
              onChange={handleInput}
            />
            {errors.question_ko && (
              <div className="text-danger fs-12">{errors.question_ko}</div>
            )}
          </div> 
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Japanese)</label>
            <input
              className="form-control"
              name="question_ja"
              value={formData.question_ja}
              onChange={handleInput}
            />
            {errors.question_ja && (
              <div className="text-danger fs-12">{errors.question_ja}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Question (Hindi)</label>
            <input
              className="form-control"
              name="question_hi"
              value={formData.question_hi}
              onChange={handleInput}
            />
            {errors.question_hi && (
              <div className="text-danger fs-12">{errors.question_hi}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (English)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeText}
              name="prescription"
              value={formData.answer}
            />
            {errors.answer && (
              <div className="text-danger fs-12">{errors.answer}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Chinese)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextCh}
              name="prescription"
              value={formData.answer_ch}
            />
            {errors.answer_ch && (
              <div className="text-danger fs-12">{errors.answer_ch}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Chinese traditional)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextZh}
              name="prescription"
              value={formData.answer_zh}
            />
            {errors.answer_zh && (
              <div className="text-danger fs-12">{errors.answer_zh}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Malay bahasa melayu)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextMs}
              name="prescription"
              value={formData.answer_ms}
            />
            {errors.answer_ms && (
              <div className="text-danger fs-12">{errors.answer_ms}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Indonesian bahasa indonesia)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextId}
              name="prescription"
              value={formData.answer_id}
            />
            {errors.answer_id && (
              <div className="text-danger fs-12">{errors.answer_id}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Vietnamese)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextVi}
              name="prescription"
              value={formData.answer_vi}
            />
            {errors.answer_vi && (
              <div className="text-danger fs-12">{errors.answer_vi}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Korean)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextKo}
              name="prescription"
              value={formData.answer_ko}
            />
            {errors.answer_ko && (
              <div className="text-danger fs-12">{errors.answer_ko}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Japanese)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextJa}
              name="prescription"
              value={formData.answer_ja}
            />
            {errors.answer_ja && (
              <div className="text-danger fs-12">{errors.answer_ja}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">Answer (Hindi)</label>
            <Editor
              apiKey="ji9nsl917eyzb6jp87j9q69i1xn9bcotyevie9itj4xl1giz"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  "advlist autolink lists link image code charmap print preview anchor",
                  "searchreplace visualblocks code fullscreen",
                  "insertdatetime media table paste code textcolor wordcount",
                  "textarea",
                  "textcolor",
                  "forecolor backcolor",
                ],
                toolbar:
                  "undo redo | formatselect | code |link | image | bold italic backcolor underline | alignleft aligncenter alignright alignjustify |  \n" +
                  "bullist numlist outdent indent | textcolor | textarea | forecolor backcolor",
                content_style: "body { color: #000 }",
              }}
              onEditorChange={handleChangeTextHi}
              name="prescription"
              value={formData.answer_hi}
            />
            {errors.answer_hi && (
              <div className="text-danger fs-12">{errors.answer_hi}</div>
            )}          
          </div>
        </div>
        <div className="card-footer text-end">
          <button type="submit" className="btn btn-primary me-2">
            Update
          </button>
          <button
            type="button"
            onClick={() =>
              navigate("/faqs-list", {
                state: { id: categoryId, title: title },
              })
            }
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>
      </form>
    </Card>
  );
}
